import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=0384010d&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=0384010d&prod&scoped=true&lang=css&"
import style1 from "./deposit.vue?vue&type=style&index=1&id=0384010d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384010d",
  null
  
)

export default component.exports